<template>
    <div class="modal-card">
        <header class="modal-card-head">
            <p class="modal-card-title">Membership Agreement</p>
        </header>
        <section class="modal-card-body">
            Some Agreement Content Will be here

        </section>
        <footer class="modal-card-foot">
            <button class="button is-info" type="button" @click="$parent.close()">Go Back</button>
        </footer>
    </div>
</template>

<script>
export default {
    name: 'MemberCondition',
    data() {
        return {

        }
    }
}
</script>

<style scoped>
.top-10 {
    margin-top: 10px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/modals/MemberCondition.vue